var map = {
	"./english-premier-league-36.png": "4177",
	"./english-premier-league-36__dark.png": "35e2",
	"./france-ligue-1-11.png": "4370",
	"./france-ligue-1-11__dark.png": "1eea",
	"./german-bundesliga-8.png": "3d60",
	"./german-bundesliga-8__dark.png": "69d5",
	"./holland-eredivisie-16.png": "9f79",
	"./holland-eredivisie-16__dark.png": "f54c",
	"./italian-serie-a-34.png": "c3a5",
	"./italian-serie-a-34__dark.png": "f27c",
	"./liga-portugal-1-23.png": "9534",
	"./liga-portugal-1-23__dark.png": "9823",
	"./saudi-professional-league-292.png": "d35a",
	"./saudi-professional-league-292__dark.png": "4bad",
	"./spanish-la-liga-31.png": "ecd3",
	"./spanish-la-liga-31__dark.png": "f63a",
	"./uefa-champions-league-103.png": "af81",
	"./uefa-champions-league-103__dark.png": "8670",
	"./uefa-europa-league-113.png": "f09b",
	"./uefa-europa-league-113__dark.png": "23a5",
	"./uefa-nations-league-1864.png": "813c",
	"./uefa-nations-league-1864__dark.png": "57b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7883";